export const GROUPING_TYPES = ['day', 'week', 'month'];
export const DEFAULT_GROUPING_TYPE = 'day';
